(function () {
  var root = document.querySelector("[data-pr-auth]");
  if (!root) return;

  var otpEnabled = root.getAttribute("data-otp") === "true";
  var workerUrl = (root.getAttribute("data-worker-url") || "").replace(/\/$/, "");
  var signedIn = root.getAttribute("data-customer") === "true";
  var accountUrl = root.getAttribute("data-account-url") || "/account";
  var loginUrl = root.getAttribute("data-login-url") || "/account/login";
  var registerUrl = root.getAttribute("data-register-url") || "/account";
  var recoverUrl = root.getAttribute("data-recover-url") || "/account/recover";
  var designMode = !!(window.Shopify && Shopify.designMode);

  var phoneForm = root.querySelector("[data-pr-auth-phone-form]");
  var otpForm = root.querySelector("[data-pr-auth-otp-form]");
  var emailForm = root.querySelector("[data-pr-auth-email-form]");
  var registerForm = root.querySelector("[data-pr-auth-register-form]");
  var recoverForm = root.querySelector("[data-pr-auth-recover-form]");
  var phoneInput = document.getElementById("PrAuthPhone");
  var otpHidden = document.getElementById("PrAuthOtp");
  var boxes = Array.prototype.slice.call(root.querySelectorAll("[data-pr-auth-otp-box]"));
  var resendBtn = root.querySelector("[data-pr-auth-resend]");
  var resendCount = root.querySelector("[data-pr-auth-resend-count]");
  var changeBtn = root.querySelector("[data-pr-auth-change]");
  var maskedEl = root.querySelector("[data-pr-auth-masked]");
  var interstitial = document.querySelector("[data-pr-auth-interstitial]");
  var doneTitle = root.querySelector("[data-pr-auth-done-title]");
  var doneCopy = root.querySelector("[data-pr-auth-done-copy]");
  var doneContinue = root.querySelector("[data-pr-auth-done-continue]");

  var state = {
    intent: "account",
    afterUrl: "",
    payload: null,
    phone: "",
    checkoutStarted: false,
    resendTimer: null,
    otpAbort: null,
    verifying: false,
  };

  /* ---------- helpers ---------- */

  function defaultStep() {
    return otpEnabled ? "phone" : "email";
  }

  function safeUrl(url) {
    if (!url) return "";
    try {
      var u = new URL(url, window.location.origin);
      if (u.origin !== window.location.origin) return "";
      return u.pathname + u.search + u.hash;
    } catch (e) {
      return "";
    }
  }

  function showError(form, message) {
    var el = form && form.querySelector("[data-pr-auth-error]");
    if (!el) return;
    if (!message) {
      el.hidden = true;
      el.innerHTML = "";
      return;
    }
    var list = Array.isArray(message) ? message : [message];
    el.innerHTML =
      '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7.5v5.5"/><path d="M12 16.5h.01"/></svg>' +
      "<ul></ul>";
    var ul = el.querySelector("ul");
    list.forEach(function (text) {
      var li = document.createElement("li");
      li.textContent = text;
      ul.appendChild(li);
    });
    el.hidden = false;
    el.setAttribute("role", "alert");
  }

  function markInvalid(form, on) {
    if (!form) return;
    form.querySelectorAll(".pr-auth__control, .pr-auth__phone-row").forEach(function (el) {
      el.classList.toggle("is-invalid", !!on);
    });
  }

  function showNotice(form, message) {
    var el = form && form.querySelector("[data-pr-auth-notice]");
    if (!el) return;
    el.hidden = !message;
    var span = el.querySelector("span");
    if (span) span.textContent = message || "";
  }

  function clearMessages(form) {
    showError(form, "");
    showNotice(form, "");
    markInvalid(form, false);
  }

  function track(name, params) {
    if (window.prTrack) window.prTrack(name, params || {});
  }

  function cartValue() {
    var bar = document.querySelector("[data-cart-total-cents]");
    var cents = bar ? Number(bar.getAttribute("data-cart-total-cents")) : NaN;
    return isNaN(cents) ? null : cents / 100;
  }

  function currentStep() {
    var panel = root.querySelector("[data-pr-auth-step]:not([hidden])");
    return panel ? panel.getAttribute("data-pr-auth-step") : "";
  }

  function setBusy(form, busy, label) {
    var btn = form && form.querySelector(".pr-auth__submit");
    if (!btn) return;
    if (!btn.dataset.label) btn.dataset.label = btn.textContent;
    btn.disabled = !!busy;
    btn.classList.toggle("is-busy", !!busy);
    btn.textContent = busy ? label || "Please wait…" : btn.dataset.label;
  }

  function focusSoon(el) {
    if (!el) return;
    window.setTimeout(function () {
      ignoreScrollUntil = Date.now() + 700;
      try {
        el.focus({ preventScroll: true });
      } catch (e) {
        el.focus();
      }
      placeSheet();
      window.setTimeout(placeSheet, 280);
    }, 60);
  }

  /* ---------- mobile sheet: above the keyboard, page stays still ---------- */

  var sheetBound = false;
  var lockedScrollY = 0;
  var pull = null;
  var ignoreScrollUntil = 0;

  function mobileSheet() {
    return window.matchMedia("(max-width: 749px)").matches;
  }

  function placeSheet() {
    if (!mobileSheet()) {
      root.style.removeProperty("--pr-auth-vv-top");
      root.style.removeProperty("--pr-auth-vv-height");
      return;
    }
    var vv = window.visualViewport;
    var top = vv ? vv.offsetTop : 0;
    var height = vv ? vv.height : window.innerHeight;
    root.style.setProperty("--pr-auth-vv-top", Math.round(top) + "px");
    root.style.setProperty("--pr-auth-vv-height", Math.round(height) + "px");
  }

  function lockPage() {
    if (!mobileSheet() || document.documentElement.classList.contains("pr-auth-locked")) return;
    lockedScrollY = window.scrollY || window.pageYOffset || 0;
    document.documentElement.classList.add("pr-auth-locked");
    document.body.style.position = "fixed";
    document.body.style.top = "-" + lockedScrollY + "px";
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.style.width = "100%";
  }

  function unlockPage() {
    if (!document.documentElement.classList.contains("pr-auth-locked")) return;
    document.documentElement.classList.remove("pr-auth-locked");
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    document.body.style.width = "";
    ignoreScrollUntil = Date.now() + 500;
    window.scrollTo(0, lockedScrollY);
  }

  function onViewportChange() {
    if (root.hidden) return;
    ignoreScrollUntil = Date.now() + 500;
    placeSheet();
  }

  function onWindowScroll() {
    if (root.hidden || !mobileSheet() || Date.now() < ignoreScrollUntil) return;
    if (!document.documentElement.classList.contains("pr-auth-locked")) return;
    var y = window.scrollY || window.pageYOffset || 0;
    if (y > lockedScrollY + 40) closeModal();
  }

  function onSheetTouchStart(event) {
    if (root.hidden || !mobileSheet()) return;
    var t = event.touches && event.touches[0];
    if (!t) return;
    pull = { y: t.clientY, inDialog: !!event.target.closest(".pr-auth__dialog") };
  }

  function onSheetTouchMove(event) {
    if (!pull || root.hidden || !mobileSheet()) return;
    var t = event.touches && event.touches[0];
    if (!t) return;
    var dy = t.clientY - pull.y;
    if (!pull.inDialog) {
      if (event.cancelable) event.preventDefault();
      if (Math.abs(dy) > 28) closeModal();
      return;
    }
    var dialog = root.querySelector(".pr-auth__dialog");
    var field = event.target.closest("input, textarea, select");
    if (!field && dialog && dialog.scrollTop <= 0 && dy > 64) closeModal();
  }

  function bindSheet() {
    if (sheetBound) return;
    sheetBound = true;
    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", onViewportChange);
      window.visualViewport.addEventListener("scroll", onViewportChange);
    }
    window.addEventListener("resize", onViewportChange);
    window.addEventListener("scroll", onWindowScroll, { passive: true });
    document.addEventListener("touchstart", onSheetTouchStart, { passive: true });
    document.addEventListener("touchmove", onSheetTouchMove, { passive: false });
    var mq = window.matchMedia("(max-width: 749px)");
    var onMq = function () {
      if (root.hidden) return;
      if (mobileSheet()) lockPage();
      else unlockPage();
      placeSheet();
    };
    if (mq.addEventListener) mq.addEventListener("change", onMq);
    else if (mq.addListener) mq.addListener(onMq);
  }

  function setStep(name) {
    if (!root.querySelector('[data-pr-auth-step="' + name + '"]')) name = defaultStep();
    var panel = root.querySelector('[data-pr-auth-step="' + name + '"]');
    // The OTP step opens after a network call, outside the tap. iOS keeps the keyboard up only if focus
    // moves straight from the still-focused phone field to the first box, before the phone panel hides.
    if (name === "otp" && boxes[0] && mobileSheet()) {
      panel.hidden = false;
      ignoreScrollUntil = Date.now() + 700;
      try {
        boxes[0].focus({ preventScroll: true });
      } catch (e) {
        boxes[0].focus();
      }
    }
    root.querySelectorAll("[data-pr-auth-step]").forEach(function (p) {
      p.hidden = p.getAttribute("data-pr-auth-step") !== name;
    });
    // iOS only raises the keyboard when focus happens inside the user's tap, so no delay here.
    if (name === "phone" && phoneInput && mobileSheet()) {
      ignoreScrollUntil = Date.now() + 700;
      try {
        phoneInput.focus({ preventScroll: true });
      } catch (e) {
        phoneInput.focus();
      }
      window.setTimeout(placeSheet, 280);
    } else if (name === "otp" && boxes[0]) {
      if (mobileSheet()) window.setTimeout(placeSheet, 280);
      else focusSoon(boxes[0]);
    }
    else focusSoon(panel && panel.querySelector("input:not([type=hidden]):not(.pr-auth__otp-hidden)"));
  }

  function openModal(opts) {
    opts = opts || {};
    state.intent = opts.intent || "account";
    state.afterUrl = safeUrl(opts.afterUrl) || "";
    state.payload = opts.payload || null;
    state.verifying = false;
    state.authed = false;
    [phoneForm, otpForm, emailForm, registerForm, recoverForm].forEach(clearMessages);
    track("pr_login_open", { intent: state.intent, step: opts.step || defaultStep(), page_type: document.body.dataset.pageType || location.pathname });
    bindSheet();
    placeSheet();
    lockPage();
    root.hidden = false;
    document.documentElement.classList.add("pr-auth-open");
    setStep(opts.step || defaultStep());
    placeSheet();
    window.setTimeout(placeSheet, 280);
  }

  function closeModal() {
    if (root.hidden) return;
    if (!state.authed) track("pr_login_closed", { step: currentStep(), intent: state.intent });
    root.hidden = true;
    document.documentElement.classList.remove("pr-auth-open");
    unlockPage();
    root.style.removeProperty("--pr-auth-vv-top");
    root.style.removeProperty("--pr-auth-vv-height");
    pull = null;
    if (state.otpAbort) state.otpAbort.abort();
    if (state.resendTimer) clearInterval(state.resendTimer);
  }

  function showInterstitial(kind) {
    if (!interstitial) return;
    var title = interstitial.querySelector(".pr-auth-interstitial__title");
    var copy = interstitial.querySelector(".pr-auth-interstitial__copy");
    if (title) title.textContent = kind === "checkout" ? "Taking you to checkout" : "Taking you to your account";
    if (copy) copy.textContent = "Just a moment…";
    interstitial.hidden = false;
    document.documentElement.classList.add("pr-auth-interstitial-open");
  }

  function hideInterstitial() {
    if (!interstitial) return;
    interstitial.hidden = true;
    document.documentElement.classList.remove("pr-auth-interstitial-open");
  }

  /* ---------- Shopify legacy account forms ---------- */

  function postForm(url, fields) {
    var ctrl = new AbortController();
    var timer = setTimeout(function () {
      ctrl.abort();
    }, 15000);
    return fetch(url, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams(fields).toString(),
      signal: ctrl.signal,
    })
      .then(function (res) {
        return res.text().then(function (html) {
          return {
            status: res.status,
            path: new URL(res.url, window.location.origin).pathname,
            doc: new DOMParser().parseFromString(html, "text/html"),
          };
        });
      })
      .finally(function () {
        clearTimeout(timer);
      });
  }

  function hasSession() {
    return fetch(accountUrl, { credentials: "same-origin" })
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        return html.indexOf("data-pr-account-page") !== -1;
      })
      .catch(function () {
        return false;
      });
  }

  // Throttled, timed-out or failed posts: use the session if it was created, otherwise hand over to a normal form post.
  function recover() {
    return hasSession().then(function (ok) {
      return ok ? "ok" : "challenge";
    });
  }

  // Full-page post, used when Shopify asks for a captcha so the customer can solve it.
  function submitNative(url, fields) {
    var form = document.createElement("form");
    form.method = "post";
    form.action = url;
    form.hidden = true;
    Object.keys(fields).forEach(function (name) {
      var input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      input.value = fields[name];
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
  }

  function errorsFrom(doc, marker) {
    var box = doc.querySelector("[data-" + marker + "]");
    if (!box) return [];
    return Array.prototype.map
      .call(box.querySelectorAll("li"), function (li) {
        return li.textContent.replace(/\s+/g, " ").trim();
      })
      .filter(Boolean);
  }

  function isAccountPage(result) {
    return !!result.doc.querySelector("[data-pr-account-page]");
  }

  function loginFields(email, password) {
    return {
      form_type: "customer_login",
      utf8: "\u2713",
      "customer[email]": email,
      "customer[password]": password,
      return_url: accountUrl,
    };
  }

  // Resolves "ok", "challenge" or an array of error messages.
  function shopifyLogin(email, password) {
    return postForm(loginUrl, loginFields(email, password))
      .then(function (result) {
        if (result.path.indexOf("/challenge") !== -1) return "challenge";
        if (isAccountPage(result)) return "ok";
        if (result.status === 429 || result.status >= 500) return recover();
        var errs = errorsFrom(result.doc, "pr-login-errors");
        return errs.length ? errs : ["Incorrect email or password."];
      })
      .catch(recover);
  }

  /* ---------- after login ---------- */

  function writeCartPhone(session) {
    var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    return fetch(rootUrl + "cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        attributes: {
          _pr_phone: (session && session.phone) || "",
          _pr_customer_id: (session && session.customerId) || "",
          _pr_phone_verified_at: new Date().toISOString(),
        },
      }),
    }).catch(function () {});
  }

  function applyMagicPhone(phone) {
    var el = document.getElementById("RazorpayMagicCheckoutConfig");
    if (!el || !phone) return;
    try {
      var cfg = JSON.parse(el.textContent || "{}");
      cfg.phone = phone;
      el.textContent = JSON.stringify(cfg);
    } catch (e) {}
  }

  function submitCheckout() {
    var form = document.getElementById("cart") || document.querySelector('form[action$="/cart"]');
    window.__prAuthCheckoutOk = true;
    var trigger = state.checkoutTrigger;
    if (trigger && trigger.isConnected && document.getElementById("RazorpayMagicCheckoutConfig")) {
      // Magic Checkout listens for clicks on the checkout button; a bare form.submit() bypasses it.
      hideInterstitial();
      track("pr_checkout_magic_open", { after_login: true });
      trigger.click();
      return;
    }
    if (form) {
      var input = document.createElement("input");
      input.type = "hidden";
      input.name = "checkout";
      input.value = "";
      form.appendChild(input);
      form.submit();
      return;
    }
    window.location.href = "/checkout";
  }

  function proceedCheckout(session) {
    if (state.checkoutStarted) return;
    state.checkoutStarted = true;
    applyMagicPhone((session && session.phone) || "");
    showInterstitial("checkout");
    var write = session && session.phone ? writeCartPhone(session) : Promise.resolve();
    write.finally(function () {
      setTimeout(submitCheckout, 1200);
    });
  }

  function setCheckoutLabels() {
    document.querySelectorAll("[data-pr-checkout-label]").forEach(function (el) {
      var text = el.getAttribute("data-pr-checkout-label");
      if (text) el.textContent = text;
    });
  }

  function continueAfterAuth(session) {
    state.authed = true;
    track("pr_login_success", {
      method: session && session.phone ? "phone" : "email",
      new_customer: !!(session && session.existing === false),
      intent: state.intent,
    });
    setCheckoutLabels();
    signedIn = true;
    document.documentElement.classList.add("pr-auth-signed-in");
    document.dispatchEvent(
      new CustomEvent("pr-auth:success", {
        detail: { intent: state.intent, afterUrl: state.afterUrl, payload: state.payload, session: session },
      })
    );
    closeModal();
    if (state.intent === "checkout") {
      proceedCheckout(session);
      return;
    }
    if (state.intent === "wishlist") {
      if (doneTitle) doneTitle.textContent = session && session.existing === false ? "You're in" : "Welcome back";
      if (doneCopy) doneCopy.textContent = "Logged in successfully.";
      root.hidden = false;
      document.documentElement.classList.add("pr-auth-open");
      setStep("done");
      return;
    }
    showInterstitial("account");
    window.location.href = state.afterUrl || accountUrl;
  }

  /* ---------- email login / register / recover ---------- */

  function validEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  if (emailForm) {
    emailForm.addEventListener("submit", function (event) {
      event.preventDefault();
      clearMessages(emailForm);
      var email = emailForm.elements.email.value.trim();
      var password = emailForm.elements.password.value;
      if (!validEmail(email) || !password) {
        markInvalid(emailForm, true);
        showError(emailForm, !validEmail(email) ? "Enter a valid email address." : "Enter your password.");
        return;
      }
      setBusy(emailForm, true, "Logging in…");
      shopifyLogin(email, password).then(function (result) {
        if (result === "ok") {
          continueAfterAuth(null);
          return;
        }
        if (result === "challenge") {
          var fields = loginFields(email, password);
          fields.return_url = state.afterUrl || accountUrl;
          submitNative(loginUrl, fields);
          return;
        }
        setBusy(emailForm, false);
        markInvalid(emailForm, true);
        showError(emailForm, result);
      });
    });
  }

  if (registerForm) {
    registerForm.addEventListener("submit", function (event) {
      event.preventDefault();
      clearMessages(registerForm);
      var f = registerForm.elements;
      var first = f.first_name.value.trim();
      var email = f.email.value.trim();
      var password = f.password.value;
      var problems = [];
      if (!first) problems.push("Enter your first name.");
      if (!validEmail(email)) problems.push("Enter a valid email address.");
      if (password.length < 5) problems.push("Password must be at least 5 characters.");
      if (problems.length) {
        showError(registerForm, problems);
        return;
      }
      var fields = {
        form_type: "create_customer",
        utf8: "\u2713",
        "customer[first_name]": first,
        "customer[last_name]": f.last_name.value.trim(),
        "customer[email]": email,
        "customer[password]": password,
        return_to: accountUrl,
      };
      setBusy(registerForm, true, "Creating account…");
      postForm(registerUrl, fields)
        .then(function (result) {
          if (result.path.indexOf("/challenge") !== -1) {
            submitNative(registerUrl, fields);
            return;
          }
          if (isAccountPage(result)) {
            continueAfterAuth({ existing: false });
            return;
          }
          if (result.status === 429 || result.status >= 500) {
            submitNative(registerUrl, fields);
            return;
          }
          var errs = errorsFrom(result.doc, "pr-register-errors");
          if (!errs.length && result.doc.querySelector("[data-pr-login-page]")) {
            // Shopify sends an existing email to the login page instead of returning an error.
            setBusy(registerForm, false);
            showError(registerForm, "An account with this email already exists. Log in, or use Forgot password to set a new one.");
            var loginEmail = emailForm && emailForm.elements.email;
            if (loginEmail) loginEmail.value = email;
            return;
          }
          if (!errs.length) {
            // Some stores send new customers home instead of /account; confirm the session.
            return shopifyLogin(email, password).then(function (login) {
              if (login === "ok") continueAfterAuth({ existing: false });
              else {
                setBusy(registerForm, false);
                showError(registerForm, "We couldn't create your account. Please try again.");
              }
            });
          }
          setBusy(registerForm, false);
          showError(registerForm, errs);
        })
        .catch(function () {
          hasSession().then(function (ok) {
            if (ok) continueAfterAuth({ existing: false });
            else submitNative(registerUrl, fields);
          });
        });
    });
  }

  if (recoverForm) {
    recoverForm.addEventListener("submit", function (event) {
      event.preventDefault();
      clearMessages(recoverForm);
      var email = recoverForm.elements.email.value.trim();
      if (!validEmail(email)) {
        markInvalid(recoverForm, true);
        showError(recoverForm, "Enter a valid email address.");
        return;
      }
      var fields = { form_type: "recover_customer_password", utf8: "\u2713", email: email };
      setBusy(recoverForm, true, "Sending…");
      postForm(recoverUrl, fields)
        .then(function (result) {
          if (result.path.indexOf("/challenge") !== -1) {
            submitNative(recoverUrl, fields);
            return;
          }
          setBusy(recoverForm, false);
          var errs = errorsFrom(result.doc, "pr-recover-errors");
          if (errs.length) {
            showError(recoverForm, errs);
            return;
          }
          showNotice(recoverForm, "If an account exists for " + email + ", we've emailed a reset link. Check your inbox and spam.");
        })
        .catch(function () {
          submitNative(recoverUrl, fields);
        });
    });
  }

  root.querySelectorAll("[data-pr-auth-eye]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var input = btn.parentNode.querySelector("input");
      var show = input.type === "password";
      input.type = show ? "text" : "password";
      btn.setAttribute("aria-label", show ? "Hide password" : "Show password");
      btn.classList.toggle("is-on", show);
    });
  });

  root.querySelectorAll("[data-pr-auth-go]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var step = btn.getAttribute("data-pr-auth-go");
      var from = btn.closest("[data-pr-auth-step]");
      var fromEmail = from && from.querySelector("input[type=email]");
      setStep(step);
      var to = root.querySelector('[data-pr-auth-step="' + step + '"] input[type=email]');
      if (to && fromEmail && fromEmail.value && !to.value) to.value = fromEmail.value;
    });
  });

  /* ---------- phone OTP ---------- */

  function api(path, body) {
    if (!workerUrl) {
      return Promise.resolve({ ok: false, error: "config", message: "Mobile login is not configured yet." });
    }
    var ctrl = new AbortController();
    var timer = setTimeout(function () {
      ctrl.abort();
    }, 15000);
    return fetch(workerUrl + path, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body || {}),
      signal: ctrl.signal,
    })
      .then(function (res) {
        return res.json().catch(function () {
          return { ok: false, error: "server", message: "Something went wrong. Try again." };
        });
      })
      .catch(function () {
        return { ok: false, error: "network", message: "Could not reach login. Check your connection and try again." };
      })
      .finally(function () {
        clearTimeout(timer);
      });
  }

  function digitsOnly(value) {
    return String(value || "").replace(/\D/g, "").slice(-10);
  }

  function otpValue() {
    return boxes
      .map(function (box) {
        return box.value.replace(/\D/g, "").slice(0, 1);
      })
      .join("");
  }

  function fillOtp(code) {
    var digits = String(code || "").replace(/\D/g, "").slice(0, 6);
    boxes.forEach(function (box, i) {
      box.value = digits.charAt(i) || "";
    });
    if (otpHidden) otpHidden.value = digits;
  }

  function startResendCountdown(seconds) {
    if (!resendBtn) return;
    var left = seconds || 30;
    if (state.resendTimer) clearInterval(state.resendTimer);
    resendBtn.disabled = true;
    resendBtn.innerHTML = 'Resend in <span data-pr-auth-resend-count></span>';
    resendCount = resendBtn.querySelector("[data-pr-auth-resend-count]");
    function tick() {
      if (left <= 0) {
        clearInterval(state.resendTimer);
        resendBtn.disabled = false;
        resendBtn.textContent = "Resend code";
        return;
      }
      resendCount.textContent = Math.floor(left / 60) + ":" + String(left % 60).padStart(2, "0");
      left -= 1;
    }
    tick();
    state.resendTimer = setInterval(tick, 1000);
  }

  function listenWebOtp() {
    if (!("OTPCredential" in window) || !navigator.credentials || !navigator.credentials.get) return;
    if (state.otpAbort) state.otpAbort.abort();
    state.otpAbort = new AbortController();
    navigator.credentials
      .get({ otp: { transport: ["sms"] }, signal: state.otpAbort.signal })
      .then(function (cred) {
        if (cred && cred.code) {
          fillOtp(cred.code);
          otpForm.requestSubmit();
        }
      })
      .catch(function () {});
  }

  if (phoneForm && phoneInput) {
    phoneInput.addEventListener("input", function () {
      var digits = phoneInput.value.replace(/\D/g, "").slice(0, 10);
      if (phoneInput.value !== digits) phoneInput.value = digits;
      if (digits.length !== 10) return;
      var btn = phoneForm.querySelector(".pr-auth__submit");
      if (btn && btn.disabled) return;
      phoneForm.requestSubmit();
    });
  }

  if (phoneForm) {
    phoneForm.addEventListener("submit", function (event) {
      event.preventDefault();
      var btn = phoneForm.querySelector(".pr-auth__submit");
      if (btn && btn.disabled) return;
      clearMessages(phoneForm);
      var phone = digitsOnly(phoneInput.value);
      if (!/^[6-9]\d{9}$/.test(phone)) {
        markInvalid(phoneForm, true);
        showError(phoneForm, "Enter a valid 10-digit Indian mobile number.");
        return;
      }
      setBusy(phoneForm, true, "Sending code…");
      if (mobileSheet() && document.activeElement !== phoneInput) {
        try {
          phoneInput.focus({ preventScroll: true });
        } catch (e) {
          phoneInput.focus();
        }
      }
      track("pr_otp_requested", { intent: state.intent });
      api("/otp/send", { phone: phone }).then(function (data) {
        setBusy(phoneForm, false);
        if (!data.ok) {
          track("pr_otp_send_failed", { reason: data.error || "unknown" });
          showError(phoneForm, data.message || "Could not send the code.");
          return;
        }
        state.phone = phone;
        if (maskedEl) maskedEl.textContent = data.phoneMasked || "+91 " + phone;
        fillOtp("");
        clearMessages(otpForm);
        setStep("otp");
        startResendCountdown(data.resendInSec || 30);
        listenWebOtp();
      });
    });
  }

  if (otpForm) {
    otpForm.addEventListener("submit", function (event) {
      event.preventDefault();
      if (state.verifying) return;
      clearMessages(otpForm);
      var code = otpValue() || (otpHidden && otpHidden.value) || "";
      if (code.length !== 6) {
        showError(otpForm, "Enter the 6-digit code.");
        return;
      }
      function fail(message, reason) {
        track("pr_otp_failed", { reason: reason || "login" });
        state.verifying = false;
        setBusy(otpForm, false);
        showError(otpForm, message);
      }
      state.verifying = true;
      setBusy(otpForm, true, "Verifying…");
      track("pr_otp_submitted", { intent: state.intent });
      api("/otp/verify", {
        phone: state.phone,
        code: code,
        wts: root.getAttribute("data-welcome-ts") || "",
        wsig: root.getAttribute("data-welcome-sig") || ""
      }).then(function (data) {
        if (!data.ok) {
          fail(data.message || "That code is incorrect.", data.error);
          if (data.error === "wrong") {
            fillOtp("");
            boxes.forEach(function (b) { b.classList.add("is-invalid"); });
            focusSoon(boxes[0]);
          }
          return;
        }
        if (!data.login) {
          fail("Your number is verified, but we could not sign you in. Please try again.");
          return;
        }
        var session = {
          phone: data.phone,
          phoneMasked: data.phoneMasked,
          customerId: data.customerId || null,
          existing: !!data.existing,
        };
        setBusy(otpForm, true, "Signing you in…");
        shopifyLogin(data.login.email, data.login.password).then(function (result) {
          if (result === "ok") {
            fillOtp("");
            continueAfterAuth(session);
            return;
          }
          if (result === "challenge") {
            var fields = loginFields(data.login.email, data.login.password);
            fields.return_url = state.intent === "checkout" ? "/cart" : state.afterUrl || accountUrl;
            submitNative(loginUrl, fields);
            return;
          }
          fail("Your number is verified, but we could not sign you in. Please try again.");
        });
      });
    });

    boxes.forEach(function (box, index) {
      box.addEventListener("input", function (event) {
        boxes.forEach(function (b) { b.classList.remove("is-invalid"); });
        var value = event.target.value.replace(/\D/g, "");
        if (value.length > 1) {
          fillOtp(value);
          if (otpValue().length === 6) otpForm.requestSubmit();
          return;
        }
        box.value = value.slice(0, 1);
        if (otpHidden) otpHidden.value = otpValue();
        if (value && boxes[index + 1]) boxes[index + 1].focus();
        if (otpValue().length === 6) otpForm.requestSubmit();
      });
      box.addEventListener("keydown", function (event) {
        if (event.key === "Backspace" && !box.value && boxes[index - 1]) boxes[index - 1].focus();
      });
      box.addEventListener("paste", function (event) {
        var text = (event.clipboardData || window.clipboardData).getData("text");
        if (!text) return;
        event.preventDefault();
        fillOtp(text);
        if (otpValue().length === 6) otpForm.requestSubmit();
      });
    });

    if (otpHidden) {
      otpHidden.addEventListener("input", function () {
        fillOtp(otpHidden.value);
        if (otpValue().length === 6) otpForm.requestSubmit();
      });
    }

    resendBtn.addEventListener("click", function () {
      if (resendBtn.disabled) return;
      resendBtn.disabled = true;
      api("/otp/resend", { phone: state.phone }).then(function (data) {
        if (!data.ok) {
          showError(otpForm, data.message || "Could not resend.");
          resendBtn.disabled = false;
          return;
        }
        clearMessages(otpForm);
        startResendCountdown(data.resendInSec || 30);
        listenWebOtp();
      });
    });

    changeBtn.addEventListener("click", function () {
      api("/otp/invalidate", { phone: state.phone });
      if (state.otpAbort) state.otpAbort.abort();
      fillOtp("");
      setStep("phone");
    });
  }

  /* ---------- openers ---------- */

  if (doneContinue) doneContinue.addEventListener("click", closeModal);
  root.querySelectorAll("[data-pr-auth-close]").forEach(function (el) {
    el.addEventListener("click", closeModal);
  });
  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && !root.hidden) closeModal();
  });

  function linkStep(href) {
    if (!href) return "";
    var path;
    try {
      path = new URL(href, window.location.origin).pathname;
    } catch (e) {
      return "";
    }
    if (/\/account\/login\/?$/.test(path)) return "login";
    if (/\/account\/register\/?$/.test(path)) return "register";
    return "";
  }

  function isCheckoutTrigger(el) {
    if (!el || !el.closest) return null;
    return el.closest("[data-sticky-checkout-btn]") || el.closest("#checkout") || el.closest("[name='checkout']") || el.closest(".cart__checkout-button");
  }

  document.addEventListener(
    "click",
    function (event) {
      if (designMode || !event.target.closest) return;

      var opener = event.target.closest("[data-pr-auth-open]");
      if (opener) {
        event.preventDefault();
        if (signedIn) {
          window.location.href = accountUrl;
          return;
        }
        openModal({
          intent: opener.getAttribute("data-pr-auth-intent") || "account",
          step: opener.getAttribute("data-pr-auth-step") || "",
          afterUrl: opener.getAttribute("data-pr-auth-return") || "",
        });
        return;
      }

      var link = !signedIn && event.target.closest("a[href]");
      var step = link ? linkStep(link.getAttribute("href")) : "";
      if (step) {
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
        openModal({ step: step === "register" ? "register" : defaultStep() });
        return;
      }

      // Checkout is never gated: Razorpay Magic handles phone and login from here.
      var checkout = isCheckoutTrigger(event.target);
      if (checkout && !window.__prAuthCheckoutOk) {
        track("pr_checkout_click", { signed_in: signedIn, cart_value: cartValue() });
        if (document.getElementById("RazorpayMagicCheckoutConfig")) {
          track("pr_checkout_magic_open", { signed_in: signedIn, cart_value: cartValue() });
        }
      }
    },
    true
  );

  window.PaintroadAuth = {
    open: function (opts) {
      opts = opts || {};
      if (signedIn) {
        state.intent = opts.intent || "account";
        state.afterUrl = safeUrl(opts.afterUrl) || "";
        state.payload = opts.payload || null;
        continueAfterAuth(null);
        return Promise.resolve(true);
      }
      openModal(opts);
      return Promise.resolve(false);
    },
    close: closeModal,
    isSignedIn: function () {
      return signedIn;
    },
  };

  if (signedIn) document.documentElement.classList.add("pr-auth-signed-in");

  /* ---------- deep links from /account/login and /account/register ---------- */

  (function () {
    var params = new URLSearchParams(window.location.search);
    var mode = params.get("pr_login");
    if (!mode || designMode) return;
    var afterUrl = params.get("return_url") || "";
    var error = params.get("pr_error");
    var sent = params.get("pr_sent");
    ["pr_login", "pr_error", "pr_sent", "return_url"].forEach(function (k) {
      params.delete(k);
    });
    var clean = window.location.pathname + (params.toString() ? "?" + params.toString() : "") + window.location.hash;
    window.history.replaceState(null, "", clean);

    if (signedIn) {
      if (afterUrl && safeUrl(afterUrl)) window.location.replace(safeUrl(afterUrl));
      return;
    }
    var step = mode === "register" ? "register" : mode === "recover" ? "recover" : defaultStep();
    if (error === "login") step = "email";
    openModal({ step: step, afterUrl: afterUrl });
    if (error === "login") showError(emailForm, "Incorrect email or password.");
    if (error === "register") showError(registerForm, "Please check your details and try again.");
    if (error === "recover") showError(recoverForm, "We couldn't send a reset link. Check the email and try again.");
    if (sent) showNotice(recoverForm, "We've emailed you a link to reset your password. Check your inbox and spam.");
  })();
})();
